"use client";

import Image from "next/image";
import React, { useState, useEffect } from "react";
import ReactStars from "react-stars";
import Trusted from "./Trusted";

const DefaultCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      id: 1,
      title: "One day ahead of schedule ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "I called Alpha for a home appraisal that was needed quickly and he was able to come the next day on a Saturday. The appraisal report was delivered one day ahead of schedule and it was thorough and of professional quality.",
      author: {
        name: "Chris C.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 2,
      title: "Quick turnaround time ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Punctual, courteous and professional. Quick turnaround time for a residential appraisal (about a week from first contact). Highly recommended!",
      author: {
        name: "James M.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 3,
      title: "Incredibly professional ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Incredibly professional and very experienced, service could not have been any better. Very accommodating to changes in appraisal appointment days and times. I recommend anyone that requires an appraisal to use Alpha Appraisals.",
      author: {
        name: "Vincent",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 4,
      title: "Such an honest and fair person ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "I don't usually write reviews but for Alpha Appraisals, I had to. Mr Khan is such an amazing man, I learned so much from this warm hearted man. Such an honest and fair person. Thank you for your help through my difficult time.",
      author: {
        name: "Marcio O.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 5,
      title: "Knowledgeable, objective, timely ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "I was very pleased with the appraisal service provided by Mushtaq Khan of Alpha Appraisals Inc. He was very knowledgeable, objective, timely and professional in his approach to completing the appraisal.",
      author: {
        name: "Douglas W.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 6,
      title: "Awesome communication ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Had a great experience working with Alpha Appraisals. Awesome communication, very fair pricing, services delivered as promised and very quick turn around times. Would highly recommend.",
      author: {
        name: "Mohammad A.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 7,
      title: "Robust, detailed and well-documented ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "My appraisal report was robust, detailed and well-documented. The report was completed in a timely manner. Mr. Khan's work was excellent and I appreciated his explanations. I would highly recommend Alpha Appraisals.",
      author: {
        name: "Michelle D.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 8,
      title: "Courteous, knowledgeable, prompt ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Mr. Mushtaq Khan helped us with the capital gain tax reporting. He was courteous, knowledgeable, prompt and very professional despite his busy schedule. We would strongly recommend Alpha Appraisals to our relatives and friends.",
      author: {
        name: "Anne-Marie P.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 9,
      title: "Extremely thorough and professional ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Alpha Appraisals has been an amazing experience. They were extremely thorough and professional, exactly what we were looking for. Definitely use this company. We are so grateful for their help.",
      author: {
        name: "Lauren B.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 10,
      title: "A pleasure to work with ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Highly recommend. Mushtaq was professional, diligent and a pleasure to work with for a residential fair market value assessment.",
      author: {
        name: "Thomas J.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
  ];

  useEffect(() => {
    const nextSlide = () => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    };

    const interval = setInterval(nextSlide, 7000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative z-10 font-cinzel  h-screen w-full overflow-hidden bg-gradient-to-b from-transparent via-white to-transparent dark:from-transparent dark:via-black dark:to-transparent dark:text-white  py-24 sm:py-32 ">
      <div className="absolute inset-0 -z-10 opacity-100 bg-gradient-to-b from-transparent via-white to-transparent dark:from-blue-700 dark:via-black" />
      <div className="absolute inset-y-0 left-1/2 -z-10  w-[200%] skew-x-[45deg] sm:skew-x-[-295deg] bg-customLightBlue dark:bg-customGrey  shadow-xl shadow-blue-600/90 ring-1 ring-blue-50 dark:ring-blue-900   origin-center" />
      <div className="mx-auto w-screen  grid items-center justify-center place-items-center text-center">
        <h2
          id="reviews"
          className="sm:text-3xl text-2xl text-yellow-600 font-extralight"
        >
          Our Recent Reviews
        </h2>

        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`mt-10 ${
              index === currentSlide ? "" : "hidden"
            } transition-opacity duration-700 ease-in-out`}
            data-carousel-item
          >
            {" "}
            <a
              href="https://maps.app.goo.gl/LQP7RigWRFxWkwLs6"
              alt="Google Reviews For Alpha Appraisals Inc"
            >
              <div className="text-center">
                <figcaption className="mt-10">
                  {" "}
                  <div className="mt-4 grid items-center justify-center text-lg">
                    <div className="font-semibold text-gray-900 dark:text-gray-200 pt-4">
                      {slide.author.name}
                    </div>
                    <div className="text-gray-600 text-center grid justify-center dark:text-gray-400 pb-10">
                      <ReactStars count={5} value={5} size={24} />
                    </div>
                  </div>
                  <blockquote className="text-xl max-w-xl font-semibold leading-8 sm:p-4 pt-10 px-16 text-gray-900 dark:text-gray-200 sm:text-3xl sm:leading-9">
                    <p>{slide.description}</p>
                  </blockquote>
                </figcaption>
              </div>{" "}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default function Review() {
  return (
    <div className="">
      <DefaultCarousel />{" "}
      <a
        href="https://maps.app.goo.gl/LQP7RigWRFxWkwLs6"
        alt="Google Business Page For Alpha Appraisals Inc"
        className=" flex justify-center "
      >
        <div className=" sm:mb-10 h-14 w-fit px-14 sm:w-1/3 flex shadow-2xl dark:shadow-slate-900  justify-center transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-black duration-300       items-center rounded-md bg-slate-900  py-2 text-base font-medium text-white hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
          <Image
            src="/google_icon.png"
            height={50}
            width={50}
            alt="google business logo"
            className="h-6 w-6 mr-2"
          />{" "}
          Leave Us A Review
        </div>
      </a>
      <Trusted />
    </div>
  );
}
